import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b877908"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 1,
  class: "text tw-text-white tw-text-center tw-text-[12px] tw-not-italic tw-font-medium tw-leading-[100%]"
}

import { Ref, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'expandingButton',
  props: {
  icon: {
    type: Object,
    required: true,
  },
  color: {
    type: String,
    default: "#387DFF",
  },
  text: {
    type: String,
    default: "Click",
  },
  maxWidth: {
    type: String,
    default: "77px",
  },
  classes: {
    type: String,
    default: "",
  },
  id: {
    type: String,
    required: false,
    default: "",
  },
},
  setup(__props) {



const isHovered: Ref<boolean> = ref(false);

const setIsHovered = (value: boolean) => {
  isHovered.value = value;
};

const handleMouseOver = () => {
  setTimeout(() => {
    setIsHovered(true);
  }, 0);
};

const handleMouseOut = () => {
  setTimeout(() => {
    setIsHovered(false);
  }, 0);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: __props.id,
    class: _normalizeClass(`expandingButton ${__props.classes}`),
    style: _normalizeStyle(
      isHovered.value
        ? `border: 1.5px solid ${__props.color};background: ${__props.color}; max-width: ${__props.maxWidth}`
        : ''
    ),
    onMouseover: handleMouseOver,
    onMouseout: handleMouseOut
  }, [
    (__props.icon)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(__props.icon), {
          key: 0,
          color: isHovered.value ? '#FFFFFF' : __props.color,
          size: 12
        }, null, 8, ["color"]))
      : _createCommentVNode("", true),
    (isHovered.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.text), 1))
      : _createCommentVNode("", true)
  ], 46, _hoisted_1))
}
}

})